import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Logo from 'components/Logo';
import React from 'react';
import { DEFAULT_HEIGTH_TO_NAVBAR_AND_CHAT_HEADER, defaultContainerWidth } from 'utils/constants';

export default function NavBar() {
  return (
    <AppBar position="relative" color="inherit" sx={{ height: `${DEFAULT_HEIGTH_TO_NAVBAR_AND_CHAT_HEADER}px`, zIndex: 1002 }}>
      <Container
        maxWidth={false}
        sx={{
          width: { xl: defaultContainerWidth, xs: '100%' },
          height: '100%',
          alignContent: 'center',
        }}
      >
        <Toolbar disableGutters>
          <Logo />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
